<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">AllPort</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="allPortForm" (ngSubmit)="register()">
                    <div class="row">
                        <div class="col-md-6">
                            <div  >
                                <label class="control-label">Parte del formulario</label>
                                <select formControlName="part" (change)="setSelectedPart($event)" class="form-control custom-select">
                                    <option selected value="1">Primera</option>
                                    <option value="2">Segunda</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedPart" class="form-body">
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="row col-md-12" formGroupName="opcA">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción A</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row col-md-12" formGroupName="opcB">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción B</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row col-md-12" *ngIf="selectedPart=='2'" formGroupName="opcC">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción C</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row col-md-12" *ngIf="selectedPart=='2'" formGroupName="opcD">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción D</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        
                    </div>
                    <div class="form-actions m-t-20">
                        <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Guardar</button>
                        <button type="button" class="btn btn-inverse" (click)="reset()">Reiniciar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>